document.addEventListener('DOMContentLoaded', () => {
  const mv = document.querySelector('.custom-mv');
  if (!mv) return;

  const slides = mv.querySelectorAll('.custom-mv__slide');
  const interval = Number(mv.dataset.slideInterval) || 5000;

  if (!slides.length) return;
  
  let current = 0;

  slides[current].classList.add('is-active');

  if (slides.length <= 1) return;

  setInterval(() => {
    slides[current].classList.remove('is-active');

    current = (current + 1) % slides.length;

    slides[current].classList.add('is-active');
  }, interval);
});